// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__Z-Wtb","cell":"ColumnAccessor_cell__2T5fv","firstCellAccent":"ColumnAccessor_firstCellAccent__2Lzyv"};